import * as React from 'react';

import type { UpsellsByDegreeSlug } from 'bundles/degree-description/types';

export type DegreeDescriptionPageUpsellsContextType = {
  stackableItemsWithUpsellType?: UpsellsByDegreeSlug;
};

export const DegreeDescriptionPageUpsellsContext = React.createContext<
  DegreeDescriptionPageUpsellsContextType | undefined
>(undefined);

export const useDegreeDescriptionUpsellsData = () => {
  const context = React.useContext(DegreeDescriptionPageUpsellsContext);
  if (!context)
    throw new Error('useDegreeDescriptionPageUpsellsContext was used outside of DegreeDescriptionPageUpsellsContext');
  return context;
};

export default DegreeDescriptionPageUpsellsContext.Provider;
